export default "__VITE_ASSET__CJ2rbqK5__"